import React, { useCallback, useState } from "react";
// @ts-ignore
import { Accordion } from "@material-ui/core";
// @ts-ignore
import { AccordionDetails } from "@material-ui/core";
// @ts-ignore
import { AccordionSummary } from "@material-ui/core";
import {
  Box,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";

import {
  SettingReports,
  SettingReportsForm,
} from "./volume/SettingReports";
import { useApi } from "../../../hooks/useApi";
import { useAsyncMemo } from "../../../hooks/utils/useAsynMemo";
import _ from "lodash";
import { Icon } from "../../../components/icon/Icon";

export interface ReportsPageProps {}

export const ReportsPage = (p: ReportsPageProps) => {
  const [filter, setFilter] = useState<SettingReportsForm>(),
    { api } = useApi();

  const volume_report_loader = useCallback(async () => {
    if (filter && filter.volumeReport) {
      try {
        const res = await api.getReportsVolume(filter);
        if (res.status === 200) {
          return res.body;
        }
      } finally {
      }
    }
    return undefined;
  }, [api, filter]);

  const markup_report_loader = useCallback(async () => {
    if (filter && filter.markupReport) {
      try {
        const res = await api.getReportsMarkup(filter);
        if (res.status === 200) {
          return res.body;
        }
      } finally {
      }
    }
    return undefined;
  }, [api, filter]);

  const fee_report_loader = useCallback(async () => {
    if (filter && filter.feeReport) {
      try {
        const res = await api.getReportsFee(filter);
        if (res.status === 200) {
          return res.body;
        }
      } finally {
      }
    }
    return undefined;
  }, [api, filter]);

  const volume_data = useAsyncMemo(volume_report_loader);
  const markup_data = useAsyncMemo(markup_report_loader);
  const fee_data = useAsyncMemo(fee_report_loader);

  return (
    <>
      <Typography variant="h4">Reports</Typography>
      <Box mt={1} />
      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <SettingReports onSubmit={setFilter} />
        </Grid>
        <Grid item xs={12} md={9}>
          {volume_data?<Typography variant="h6">Volume Report</Typography>:null}
          {volume_data &&
            _.map(volume_data, (d) => (
                <Accordion>
                  <AccordionSummary expandIcon={<Icon icon="faChevronDown" />}>
                    <Typography>{_.upperFirst(d.name)}</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>{_.upperFirst(d.name)}</TableCell>
                          <TableCell>Volume</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {_.map(d.rows, (r) => (
                          <TableRow>
                            <TableCell>{r.name}</TableCell>
                            <TableCell>{r.value}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </AccordionDetails>
                </Accordion>
            ))}
          {markup_data?<Typography variant="h6">Markup Report</Typography>:null}
          {markup_data &&
            _.map(markup_data, (d) => (
              <Accordion>
                <AccordionSummary expandIcon={<Icon icon="faChevronDown" />}>
                  <Typography>{_.upperFirst(d.name)}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>{_.upperFirst(d.name)}</TableCell>
                        <TableCell>Value</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {_.map(d.rows, (r) => (
                        <TableRow>
                          <TableCell>{r.name}</TableCell>
                          <TableCell>{r.value}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </AccordionDetails>
              </Accordion>
            ))}
          {fee_data?<Typography variant="h6">Fee Report</Typography>:null}
          {fee_data &&
            _.map(fee_data, (d) => (
              <Accordion>
                <AccordionSummary expandIcon={<Icon icon="faChevronDown" />}>
                  <Typography>{_.upperFirst(d.name)}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>{_.upperFirst(d.name)}</TableCell>
                        <TableCell>Value</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {_.map(d.rows, (r) => (
                        <TableRow>
                          <TableCell>{r.name}</TableCell>
                          <TableCell>{r.value}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </AccordionDetails>
              </Accordion>
            ))}
        </Grid>
      </Grid>
    </>
  );
};
